<script setup lang="ts">
import { RouterLink, useRouter } from "vue-router";

import { useInflectionTrainerWordClass } from "@/common/composables/use-inflection-trainer-word-class";
import SearchInfoBox from "@/components/article/SearchInfoBox.vue";
import { changeQueryParam } from "@/router/util/change-query-param";
import type { WordClass } from "@/types/inflection-trainer.type";

const props = defineProps<{
  word: string;
  wordClass: WordClass;
}>();

const emit = defineEmits<{
  close: [];
  wordClassClick: [WordClass];
}>();

const router = useRouter();

const { translatedWordClass } = useInflectionTrainerWordClass(props.wordClass);

const onClose = () => {
  emit("close");
};

const onWordClassClick = (event: PointerEvent, wordClass: WordClass) => {
  if (event.ctrlKey || event.metaKey || event.shiftKey) {
    // Let default event handling take over
    return;
  }

  event.preventDefault();
  emit("wordClassClick", wordClass);
};
</script>

<template>
  <SearchInfoBox class="word-exists-in-other-word-class-info-box" @close="onClose()">
    <i18n-t keypath="inflection-trainer.word-exists-in-other-word-class-info-box">
      <template #word>
        <span
          class="word-exists-in-other-word-class-info-box__prominent-text word-exists-in-other-word-class-info-box__prominent-text--bold"
        >
          {{ word }}
        </span>
      </template>
      <template #wordClass>
        <RouterLink
          :to="changeQueryParam(router, 'wordClass', props.wordClass)"
          class="word-exists-in-other-word-class-info-box__prominent-text word-exists-in-other-word-class-info-box__prominent-text--secondary"
          @click="onWordClassClick($event, props.wordClass)"
        >
          {{ translatedWordClass }}
        </RouterLink>
      </template>
    </i18n-t>
  </SearchInfoBox>
</template>

<style lang="less" scoped>
@import "@/less/components/inflection-trainer/word-exists-in-other-word-class-info-box.less";
</style>
